import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const purchaseLoadPhotosQueryAtom = createQueryAtomFactory(
  'trade.purchaseLoadPhotos',
  (params: { id: string }) => ({
    purchaseLoad: {
      __args: {
        id: params.id,
      },
      files: {
        id: true,
        fileName: true,
        fileSize: true,
        mimeType: true,
        status: true,
        metadata: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    },
  }),
  {
    select: ({ purchaseLoad }) => purchaseLoad?.files ?? [],
  },
);
